import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'

interface Props {
  /** Object URL of the fetched PDF; `null` closes the modal. */
  url: string | null
  title: string
  onDownload(): void
  onClose(): void
}

/**
 * Shows a report PDF inline. Not `FilePreviewModal`: that one downloads through a bare
 * `<a download>` with no file name and has no Close button.
 */
const FeeWithdrawalReportPreviewModalComponent = ({ url, title, onDownload, onClose }: Props) => {
  return (
    <CommonModal
      isOpen={url !== null}
      title={title}
      className={tw`max-w-[960px]`}
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" onClick={onClose}>
            Close
          </Button>
          <Button
            size="small"
            color="dark"
            onClick={onDownload}
            data-testid="fee-withdrawal-preview-download"
          >
            Download
          </Button>
        </Fragment>
      }
    >
      {url ? (
        <object
          data={url}
          type="application/pdf"
          css={tw`h-[70vh] w-full`}
          data-testid="fee-withdrawal-preview-object"
        >
          <Typography variant="body2" css={tw`m-4`}>
            This browser cannot show the PDF here — use Download instead.
          </Typography>
        </object>
      ) : null}
    </CommonModal>
  )
}

export const FeeWithdrawalReportPreviewModal = memo(FeeWithdrawalReportPreviewModalComponent)
